import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-manage-notifications',
  templateUrl: './manage-notifications.component.html',
  styleUrls: ['./manage-notifications.component.scss']
})
export class ManageNotificationsComponent {
  criteria = {
    keyword: undefined,
    userId: undefined,
    isRead: false,
    type: 'Recieved'
  }

}
